import { render, staticRenderFns } from "./createSurvey.vue?vue&type=template&id=5c016ef9&scoped=true&"
import script from "./createSurvey.vue?vue&type=script&lang=js&"
export * from "./createSurvey.vue?vue&type=script&lang=js&"
import style0 from "./createSurvey.vue?vue&type=style&index=0&id=5c016ef9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c016ef9",
  null
  
)

export default component.exports